export default "__VITE_ASSET__a20b57ab__"